<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full">
      <template #title>
        <a-row type="flex" align="middle">
          <a-col :span="12" :md="12">
            <a-button
              type="primary"
              icon="plus"
              size="small"
              @click="AddClick"
              style="margin-right: 10px"
              v-if="isAdmin"
            >
              新增分类
            </a-button>
          </a-col>
          <a-col
            :span="12"
            :md="12"
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            "
          >
            <a-input
              v-model="Query.skey"
              placeholder=""
              size="small"
              style="width: 150px; margin-right: 10px"
            />
            <a-button
              type="primary"
              icon="search"
              size="small"
              @click="SearchClieck"
            >
              查询
            </a-button>
          </a-col>
        </a-row>
      </template>

      <a-table
        :columns="columns"
        :data-source="tableData"
        :pagination="false"
        size="small"
        :expand-column-width="100"
        :expandRowByClick="true"
      >
        <!-- <template #expandedRowRender="row">
          <a-tag v-for="item in row.typeList" :key="item.id" color="#108ee9">{{
            item.keytype
          }}</a-tag>
        </template> -->
        <template slot="editBtn" slot-scope="row">
          <a-button
            type="primary"
            icon="edit"
            shape="round"
            :data-id="row.id"
            size="small"
            style="margin-right: 10px"
            @click="CateEditClick(row)"
            >编辑</a-button
          >
          <a-button
            type="danger"
            icon="delete"
            shape="round"
            :data-id="row.id"
            size="small"
            @click="CateDelClick(row)"
            >删除</a-button
          >
        </template>
      </a-table>

      <div class="PageCom">
        <el-pagination
          background
          :current-page="Page.index"
          :page-sizes="Page.sizes"
          :page-size="Page.size"
          :total="Page.total"
          layout="sizes, total, prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </a-card>
  </div>
</template>

<script>
import { getCategoryList, CategoryDel } from "@/api/category";
import store from "@/store";
export default {
  data() {
    return {
      columns: [
        {
          title: "分类名称",
          dataIndex: "cateName",
          key: "cateName",
        },
        {
          title: "添加用户",
          dataIndex: "addUserName",
          key: "addUserName",
        },
        { title: "创建时间", dataIndex: "createTime", key: "createTime" },
      ],
      Query: {
        skey: "",
      },
      tableData: [],
      Page: {
        index: 1,
        size: 10,
        sizes: [10, 50, 100, 200, 500, 1000],
        total: 0,
      },
      isAdmin: store.getters.roles.includes("admin"),
    };
  },
  created() {
    this.GetTableData(this.Query);
    if (this.isAdmin) {
      this.columns.push({
        title: "操作",
        key: "editBtn",
        scopedSlots: { customRender: "editBtn" },
      });
    }
  },
  methods: {
    handleSizeChange(val) {
      this.Page.size = val;
      this.GetTableData(this.Query);
    },
    handleCurrentChange(val) {
      this.Page.index = val;
      this.GetTableData(this.Query);
    },
    GetTableData(query) {
      getCategoryList(query.skey, this.Page.index, this.Page.size).then(
        (res) => {
          if (res.code == 0) {
            this.tableData = res.data.data;
            this.Page.total = res.data.total;
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    SearchClieck() {
      this.Page.index = 1;
      this.GetTableData(this.Query);
    },
    AddClick() {
      var cateMod = {
        id: "",
        cateName: "",
        cateState: true,
      };
      this.$emit("addClick", cateMod);
    },
    CateEditClick(row) {
      this.$emit("EditCateClick", row);
    },
    CateDelClick(row) {
      this.$confirm("此操作将永久删除此分类, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          CategoryDel(row.id).then((res) => {
            console.log(res);
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.GetTableData(this.Query);
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
</style>